module.exports = __webpack_public_path__ + "img/no_file_icon.b0520ce7.svg";